const { APP_ROUTES } = require('modules/routes/constants/index.cjs')

export default function isAppRouteUtil (path) {
  return !!APP_ROUTES.find(routePath => (path || '').startsWith(routePath))
}
